import * as React from "react";

import { cn } from "@/lib/utils";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
	disableFocusStyle?: boolean;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
	({ className, disableFocusStyle = false, ...props }, ref) => {
		return (
			<textarea
				className={cn(
					"flex min-h-[80px] w-full rounded-md border-2 border-border/60 dark:border-border/40 hover:border-border/80 dark:hover:border-border/60 bg-background/80 dark:bg-input/80 backdrop-blur-sm px-3 py-2 text-base shadow-xs transition-[color,box-shadow,border-color,background-color] outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
					!disableFocusStyle && "input-focus-blue",
					className
				)}
				ref={ref}
				{...props}
			/>
		);
	}
);
Textarea.displayName = "Textarea";

export { Textarea };
